import { Stack, SxProps, styled } from '@/theme/index';

const RippleLoadingComponent = styled(Stack)(({ theme }) => ({
  justifyContent: 'center',
  alignItems: 'center',
  '.lds-ripple': {
    display: 'inline-block',
    position: 'relative',
    width: '80px',
    height: '80px',
  },
  '.lds-ripple div': {
    position: 'absolute',
    border: `4px solid ${theme.palette.primary.main}`,
    opacity: '1',
    borderRadius: '50%',
    animation: 'lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite',
  },
  '.lds-ripple div:nth-of-type(2)': {
    animationDelay: '-0.5s',
  },
  '@keyframes lds-ripple': {
    '0%': {
      top: '36px',
      left: '36px',
      width: 0,
      height: 0,
      opacity: 0,
    },
    '4.9%': {
      top: '36px',
      left: '36px',
      width: 0,
      height: 0,
      opacity: 0,
    },
    '5%': {
      top: '36px',
      left: '36px',
      width: 0,
      height: 0,
      opacity: 1,
    },
    '100%': {
      top: '0px',
      left: '0px',
      width: '72px',
      height: '72px',
      opacity: 0,
    },
  },
}));
interface RippleLoadingProps {
  sx?: SxProps;
}
export const RippleLoading = ({ sx }: RippleLoadingProps) => {
  return (
    <RippleLoadingComponent sx={sx}>
      <div className="lds-ripple">
        <div />
        <div />
      </div>
    </RippleLoadingComponent>
  );
};
